<template>
  <div>
    <h1 class="text-gray-500 text-md mb-2 mt-2" >
      Select images from existing datasets, or upload new images.
    </h1>

    <div v-if="!imageSelected">
      <label
        for="selectedRepo"
        class="mt-2 block text-sm leading-5 font-medium text-gray-700 mb-2"
        >Repository</label
      >
      <v-select
        v-model="selectedRepo"
        :options="repos"
        label="name"
        class="mb-4"
        placeholder="Choose repository..."
      ></v-select>

      <label
        for="dataset"
        class="mt-2 block text-sm leading-5 font-medium text-gray-700 mb-2"
        v-if="selectedRepo"
        >Dataset</label
      >
      <v-select
        v-model="selectedDataset"
        :options="availableDatasets"
        label="name"
        class="mb-4"
        v-if="selectedRepo"
        placeholder="Choose dataset..."
      ></v-select>

      <div
        v-if="data.length > 0"
        class="flex flex-row flex-wrap px-4 pb-4 border border-gray-300
            overflow-scroll bg-gray-100 rounded-md "
        style="max-height:500px"
      >
        <img
          v-for="(img, idx) in data"
          :src="img.url"
          class="h-20 mt-4 mr-4 cursor-pointer border-2 border-gray-400
          hover:border-blue-400"
          @click="selectImage(img)"
        />
      </div>
      <span v-else class="text-blue-500">
        No images or videos available.
      </span>
      <div class="flex flex-row justify-end">
        <button
          v-if="selectedRepo"
          aria-label="Upload a new image"
          data-balloon-pos="up"
          @click="uploadImage"
          class="mt-4 inline-flex justify-center py-2 px-4 border
              border-transparent pt-3 text-sm leading-5 font-medium rounded-md
              text-white bg-light-blue-500 hover:bg-light-blue-400
              focus:outline-none focus:border-light-blue-600
              focus:shadow-outline-blue active:bg-light-blue-600 transition
              duration-150 ease-in-out"
        >
          <!-- UPLOAD ICON -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011
                  9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            />
          </svg>
        </button>
      </div>
    </div>
    <div v-if="imageSelected">
      <div class="flex flex-row justify-end">
        <button
          aria-label="Upload a new image"
          data-balloon-pos="up"
          class="mt-4 inline-flex justify-center py-2 px-4 border
              border-transparent pt-2 text-sm leading-5 font-medium rounded-md
              text-white bg-gray-500 hover:bg-light-blue-400
              focus:outline-none focus:border-light-blue-600
              focus:shadow-outline-blue active:bg-light-blue-600 transition
              duration-150 ease-in-out"
          @click="
            element.url = '';
            imageSelected = false;
          "
        >
          Change
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import Component from "../component_location"
import { openFilePicker, reportError } from "@/utils.js";
import { getData } from "@/views/Datasets/api.js";

export default {
  components: {},

  props: ["element", "repos"],

  data() {
    return {
      uploading: false,
      imageSelected: false,
      selectedRepo: null,
      selectedDataset: null,
    };
  },

  watch: {
    element: function() {
      if (this.element.url.length > 5) {
        this.imageSelected = true;
      }
    },

    selectedDataset: function(dataset) {
      if (!dataset.isConnected) {
        return; // no data available
      }

      getData(dataset, 0, 100)
        .then((res) => {
          this.$store.commit("setData", res.data.data.select);
        })
        .catch((err) => {
          reportError(err);
        });
    },
  },

  methods: {
    uploadImage() {
      // UPLOAD NEW IMAGE.
      this.uploading = true;
      const client = openFilePicker();
      var dataType = this.selectedDataset.mimetype.split("/")[0];
      var acceptType = dataType + "/*"; // only accept matching data types...
      var options = {
        accept: [acceptType],
        onUploadDone: this.filesUploaded,
        onCancel: (e) => {
          this.uploading = false;
        },
        maxFiles: 100,
        transformations: { crop: false, circle: false, rotate: false },
      };
      client.picker(options).open();
    },

    filesUploaded(fileInfo) {
      var filesUploaded = fileInfo.filesUploaded;
      // Remove the originalFile embedded document business — redundant information.
      filesUploaded.forEach((file) => {
        delete file.originalFile;
      });

      this.$samsa
        .uploadImages(this.element.narrative_id, filesUploaded)
        .then((res) => {
          
        })
        .catch((err) => {
          reportError(err);
        });
    },

    selectImage(img) {
      this.element.url = img.url;
      this.imageSelected = true;
    },

    retrieveData() {
      getData(this.dataset, 0, 100)
        .then((res) => {
          this.$store.commit("setData", res.data.data.select);
        })
        .catch((err) => {
          reportError(err);
        });
    }

  },

  computed: {
    data() {
      return this.$store.state.data;
    },

    dataset() {
      return this.$store.state.dataset
    },

    availableDatasets() {
      if (this.selectedRepo) {
        return this.selectedRepo.datasets;
      } else {
        return [];
      }
    },
  },

  mounted() {
    this.selectedDataset=null
  },
};
</script>

<style></style>
